module.exports = __webpack_public_path__ + "static/media/math.7089c085.jpg";